import { ReactNode } from 'react';
import { Toaster } from '@/components/ui/toaster';
import { Navigation } from '@/domain/navigation/features/navigation/Navigation';

export function DefaultPage({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="flex flex-col h-screen bg-neutrals-200">
        <div className="shrink-0">
          <Navigation />
        </div>
        <div className="overflow-auto" id="body-container">
          {children}
        </div>
      </div>
      <Toaster />
    </>
  );
}
